import { register } from "async-ops";
import { callMvcApi } from "../../../call-web-api";
export const GET_PROCESS_MANAGERS_LIST = "GET_PROCESS_MANAGERS_LIST";

export const service = async (featureGroupName) => {
  const options: object = {
    url: `/Api/ExternalAudit/GetProcessManager/${featureGroupName}`,
    method: "GET",
  };
  const response = callMvcApi(options);
  return response;
};

const mockData = () => {
  return [];
};

const mock = () => {
  const promise = new Promise((resolve, reject) => {
    setTimeout(() => {
      resolve(mockData());
    }, 2000);
  });
  return promise;
};

register(GET_PROCESS_MANAGERS_LIST, service, mock);
